module.exports = __webpack_public_path__ + "img/image155.99f93d4f.jpg";